import { unionBy } from 'lodash'

import { useLatestCallback } from '@marketplace-web/shared/ui-helpers'

import { getCatalogDefaultFilters } from 'data/api'
import { transformSelectedDefaultDynamicFilters } from 'data/transformers/dynamic-filter'
import { DynamicFilterReducerAction } from 'pages/Catalog/CatalogProvider/reducers/actionTypes'
import useCatalogContext from 'pages/Catalog/CatalogProvider/useCatalogContext'
import { SelectedDynamicFilterModel } from 'types/models/dynamic-filter'

import useFetchDynamicFilters from './useFetchDynamicFilters'

type FetchDefaultDynamicFiltersParams = {
  selectedDynamicFilters: Array<SelectedDynamicFilterModel>
  currentCatalogIds?: Array<number>
  isTemporary?: boolean
}

const useFetchDefaultDynamicFilters = () => {
  const { dispatch } = useCatalogContext()
  const fetchDynamicFilters = useFetchDynamicFilters()

  const fetchDefaultDynamicFilters = useLatestCallback(
    async ({
      selectedDynamicFilters,
      currentCatalogIds,
      isTemporary,
    }: FetchDefaultDynamicFiltersParams) => {
      let payload: { catalogIds: Array<number> }
      const selectedCatalogIds = currentCatalogIds || []

      dispatch({
        type: DynamicFilterReducerAction.FETCH_DEFAULT_DYNAMIC_FILTERS_REQUEST,
        payload: undefined,
      })

      if (isTemporary) {
        payload = {
          catalogIds: selectedCatalogIds,
        }
      } else {
        payload = {
          catalogIds: selectedCatalogIds,
        }
      }

      const response = await getCatalogDefaultFilters(payload)

      if ('errors' in response) {
        dispatch({
          type: DynamicFilterReducerAction.FETCH_DEFAULT_DYNAMIC_FILTERS_FAILURE,
          payload: { errors: response.errors },
        })
      } else {
        const defaultFilters = transformSelectedDefaultDynamicFilters(response.defaults || [])
        const finalSelectedFilters = unionBy(defaultFilters, selectedDynamicFilters, 'type')

        dispatch({
          type: DynamicFilterReducerAction.FETCH_DEFAULT_DYNAMIC_FILTERS_SUCCESS,
          payload: {
            selectedDefaultFilters: defaultFilters,
          },
        })

        if (isTemporary) {
          fetchDynamicFilters({
            selectedDynamicFilters: finalSelectedFilters,
            selectedTemporaryCatalogIds: selectedCatalogIds,
            isTemporary: true,
          })
        } else {
          fetchDynamicFilters({
            selectedDynamicFilters: finalSelectedFilters,
            selectedFilters: { catalogIds: selectedCatalogIds },
          })
        }
      }
    },
  )

  return fetchDefaultDynamicFilters
}

export default useFetchDefaultDynamicFilters
